<template>
	<div class="ms-no-data">
		<div v-if="noDataSlot">
			<slot name="noData"></slot>
		</div>
		<div v-else class="no-data-content">
			<div class="img-nodata">
				<div
					v-if="options && options.isShowEmptyData"
					class="mi-new-v2 mi-icon-v2-empty-data-grid"
				></div>
				<div
					v-else
					:class="[
						isScreenMall
							? 'mi-new-v2 mi-icon-v2-search-cannot-find-data-small'
							: 'mi mi-icon-v2-search-cannot-find-data',
					]"
				></div>
			</div>
			<div
				class="ms-mgt-16px title-header-form ms-line-height-22px ms-grid-no-data-title flex items-center justify-center"
				v-if="!options || !options.disableTitle"
				:class="options.titleClass"
			>
				{{
					options && options.title
						? options.title
						: $t('i18nCommon.CannotFindData')
				}}
			</div>
			<div
				class="ms-mgt-4px ms-line-height-20px ms-grid-no-data-sub-title flex items-center justify-center"
				v-if="!options || !options.disableSubTitle"
				:class="options.subTitleClass"
			>
				{{
					options && options.subTitle
						? options.subTitle
						: $t('i18nCommon.FilterAgain')
				}}
			</div>
		</div>
	</div>
</template>
<script>
/**
 * Component UI "không có dữ liệu" dùng chung cho msGridViewer, msTreeViewer và các màn hình khác
 * cần hiển thị trạng thái rỗng đồng nhất (icon + tiêu đề + phụ đề, hoặc slot tùy chỉnh)
 */
export default {
	name: 'msNoData',
	props: {
		/**
		 * true: hiển thị slot "noData" tùy chỉnh từ ngoài thay vì UI mặc định
		 */
		noDataSlot: {
			type: Boolean,
			default: false,
		},
		/**
		 * Cấu hình tùy chỉnh UI khi không có dữ liệu
		 * isShowEmptyData: hiển thị icon empty-data (chưa từng có dữ liệu) thay vì icon search-not-found
		 * title/subTitle: text tùy chỉnh
		 * disableTitle/disableSubTitle: ẩn title/subTitle
		 * titleClass/subTitleClass: class tùy chỉnh
		 */
		options: {
			type: Object,
			default: () => ({}),
		},
		isScreenMall: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {};
	},
};
</script>
<style lang="scss" scoped>
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/components/msGridViewer.scss';
}
@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/components/msGridViewer.scss';
}

.no-data-content {
	margin-bottom: 24px;
}

.mi-icon-v2-search-cannot-find-data {
	background: url('~@/assets/images/sprites_01.svg') no-repeat -336px -808px;
	width: 260px;
	height: 180px;
}
</style>
